import {css} from '@emotion/css';

import {colours, spacing} from '../../../styles/js/variables';
import {mq, Breakpoints, layout} from '../../../styles/js/mixins';

const styles = {
  container: (isReversed?: boolean): string => css`
    label: infoImageBlock__container;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq(Breakpoints.TABLET)} {
      flex-direction: ${isReversed ? 'row-reverse' : 'row'};
      justify-content: space-between;
    }
  `,
  info: css`
    label: infoImageBlock__info;
    ${layout.columnHalf};
    width: 100%;
    max-width: 100%;
    padding: 0;

    ${mq(Breakpoints.TABLET)} {
      padding: ${spacing.XS};
    }

    h4 {
      color: ${colours.brand.SECONDARY};
    }
    .paragraph {
      color: ${colours.font.ASSISTIVE};
    }
  `,
  image: css`
    label: infoImageBlock__image;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: ${spacing.XS};
  `,

};

export default styles;
